// src/dialogs/MoveCancelModal.tsx
import React from "react";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { Checkbox, FormControlLabel, InputAdornment, MenuItem, TextField } from "@mui/material";
import { BiMessageAltDetail } from "react-icons/bi";

// src/dialogs/modal/Modal.tsx
import { Dialog } from "@mui/material";
import { useTheme, Box } from "@mui/material";
import { jsx } from "react/jsx-runtime";
var Modal = ({ open, width = "sm", handleClose, children }) => {
  const theme = useTheme();
  const sxStyles = useSxStyles(theme);
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open,
      onClose: () => {
        if (handleClose) handleClose();
      },
      maxWidth: width,
      PaperProps: { sx: { ...sxStyles.root } },
      disableEscapeKeyDown: true,
      scroll: "body",
      children: /* @__PURE__ */ jsx(Box, { sx: sxStyles.main, children })
    }
  );
};
var Modal_default = Modal;
var useSxStyles = (theme) => ({
  root: {
    width: "100%",
    margin: theme.spacing(2)
  },
  main: {
    position: "relative",
    textAlign: "left"
  }
});

// src/dialogs/modal/ModalHeader.tsx
import { useTheme as useTheme2, DialogTitle, IconButton, Icon } from "@mui/material";
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var ModalHeader = ({ handleClose, children }) => {
  const theme = useTheme2();
  const sxStyles = useSxStyles2(theme);
  return /* @__PURE__ */ jsxs("span", { style: sxStyles.container, children: [
    /* @__PURE__ */ jsx2(DialogTitle, { sx: sxStyles.title, children }),
    handleClose && /* @__PURE__ */ jsx2(IconButton, { sx: sxStyles.close, onClick: handleClose, "aria-label": "close", children: /* @__PURE__ */ jsx2(Icon, { children: "close" }) })
  ] });
};
var ModalHeader_default = ModalHeader;
var useSxStyles2 = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 1, 1, 2)
  },
  title: {
    padding: 0,
    margin: 0,
    lineHeight: 1.2,
    fontSize: "20px",
    fontWeight: 600
  },
  close: {
    padding: theme.spacing(1),
    color: theme.palette.text.primary
  }
});

// src/dialogs/modal/ModalContent.tsx
import { Typography, DialogContent, Box as Box2 } from "@mui/material";
import { useTheme as useTheme3 } from "@mui/material/styles";
import { Fragment, jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ModalContent = ({
  subtitle,
  disableDividers = false,
  children
}) => {
  const theme = useTheme3();
  const sxStyles = useSxStyles3(theme);
  return /* @__PURE__ */ jsxs2(DialogContent, { dividers: !disableDividers, sx: sxStyles.padding, children: [
    subtitle && /* @__PURE__ */ jsxs2(Fragment, { children: [
      /* @__PURE__ */ jsx3(Typography, { sx: sxStyles.subtitle, children: subtitle }),
      /* @__PURE__ */ jsx3(Box2, { sx: sxStyles.break })
    ] }),
    children
  ] });
};
var ModalContent_default = ModalContent;
var useSxStyles3 = (theme) => ({
  padding: {
    padding: theme.spacing(2),
    margin: 0,
    display: "block",
    overflowY: "auto"
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: "14px",
    fontWeight: 400
  },
  break: {
    width: "100%",
    height: theme.spacing(2)
  }
});

// src/dialogs/modal/ModalFooter.tsx
import { DialogActions } from "@mui/material";
import { useTheme as useTheme4 } from "@mui/material/styles";
import { jsx as jsx4 } from "react/jsx-runtime";
var ModalFooter = ({ children }) => {
  const theme = useTheme4();
  const sxStyles = useSxStyles4(theme);
  return /* @__PURE__ */ jsx4(DialogActions, { sx: sxStyles.padding, children });
};
var ModalFooter_default = ModalFooter;
var useSxStyles4 = (theme) => ({
  padding: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    margin: 0,
    background: theme.palette.grey[50]
  }
});

// src/dialogs/modal/ModalAction.tsx
import { Button } from "@mui/material";
import { jsx as jsx5 } from "react/jsx-runtime";
var ModalAction = ({
  className,
  onClick,
  color = "primary",
  size = "medium",
  variant = "text",
  disabled,
  children,
  loading,
  ...props
}) => {
  return /* @__PURE__ */ jsx5(
    Button,
    {
      className,
      onClick,
      color,
      size,
      variant,
      disabled: disabled || loading,
      ...props,
      children
    }
  );
};
var ModalAction_default = ModalAction;

// src/dialogs/requestMoveCancel.mutation.generated.ts
import { resolveExecutor } from "@hopdrive/sdk-core";
var RequestMoveCancelDocument = { "__text": 'mutation requestMoveCancel($id: bigint!, $cancel_status: String = "pending", $cancel_reason: String) {\n  update_moves(\n    where: {id: {_eq: $id}}\n    _set: {cancel_requested_at: "now()", cancel_status: $cancel_status, cancel_reason: $cancel_reason}\n  ) {\n    affected_rows\n    returning {\n      id\n      cancel_requested_at\n      cancel_status\n      cancel_reason\n      status\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestMoveCancel" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "cancel_status" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } }, "defaultValue": { "kind": "StringValue", "value": "pending", "block": false } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "cancel_reason" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "id" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_requested_at" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_status" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "cancel_status" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_reason" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "cancel_reason" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_requested_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "status" } }] } }] } }] } }] };

// src/dialogs/moveCancelDecisions.ts
var canAutoCancelMove = (move) => {
  const hasNoDriver = move?.driver_id === null || move?.driver_id === void 0;
  const hasNoPickupTimestamps = !move?.pickup_started && !move?.pickup_arrived && !move?.pickup_successful;
  const hasNoDeliveryTimestamps = !move?.delivery_started && !move?.delivery_arrived && !move?.delivery_successful;
  const statusIsUnconfirmed = move?.status === null || move?.status === void 0 || move?.status === "unconfirmed";
  const scenarios = move?.scenariotomoves || [];
  const hasNoBundleOffers = !scenarios.some((scenarioToMove) => {
    const bundletoscenarios = scenarioToMove?.scenario?.bundletoscenarios || [];
    return bundletoscenarios.some((bundleToScenario) => (bundleToScenario?.bundle?.offers || []).length > 0);
  });
  return hasNoDriver && hasNoPickupTimestamps && hasNoDeliveryTimestamps && statusIsUnconfirmed && hasNoBundleOffers;
};
var isLiveDriveLeg = (leg) => {
  if (!leg || leg.move_type !== `drive`) return false;
  if (leg.active === 0) return false;
  return leg.cancel_status == null || leg.cancel_status === `pending`;
};
var resolveLegsToCancel = (move) => {
  const legs = [move, move?.parentMove, ...move?.childMoves || []];
  const ids = legs.filter((leg) => !!leg?.id && isLiveDriveLeg(leg)).map((leg) => leg?.id);
  return Array.from(new Set(ids));
};
var cancelReasons = [
  { label: "Contact not reachable", value: "Contact not reachable" },
  { label: "Created by mistake", value: "Created by mistake" },
  { label: "Customer canceled previously", value: "Customer canceled previously" },
  { label: "Customer changed address", value: "Customer changed address" },
  { label: "Customer needed to reschedule", value: "Customer needed to reschedule" },
  { label: "Customer not present", value: "Customer not present" },
  { label: "Duplicate move request", value: "Duplicate move request" },
  { label: "Incorrect address", value: "Incorrect address" },
  { label: "Vehicle mechanical failure", value: "Vehicle mechanical failure" },
  { label: "Vehicle moved previously", value: "Vehicle moved previously" },
  { label: "Vehicle not ready", value: "Vehicle not ready" },
  { label: "Vehicle not roadworthy", value: "Vehicle not roadworthy" }
];

// src/dialogs/MoveCancelModal.tsx
import { Fragment as Fragment2, jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var log = false;
var MoveCancelModal = (props) => {
  const { open, onClose, moveInput, adminUrl, getAuthToken, onError } = props;
  const [requestMoveCancelMutation] = useMutation(RequestMoveCancelDocument);
  const [cancelReason, setCancelReason] = React.useState("");
  const [showError, setShowError] = React.useState(false);
  const [useSharedReason, setUseSharedReason] = React.useState(true);
  const [reasonByMoveId, setReasonByMoveId] = React.useState({});
  const createNotification = async () => {
    try {
      if (!adminUrl || !getAuthToken) {
        log && console.error("No admin notification transport supplied; skipping.");
        return;
      }
      const variables = {
        type: "action",
        title: `Move ${moveInput?.id} Pending Cancel`,
        body: `Move ${moveInput?.id} is pending cancel. Click the link in the notes below to visit the details page and update the cancel status.`,
        createdat: "now()",
        createdby: "move-cancel.dealer",
        notes: `[Click to go to Move Details](${adminUrl}moves/${moveInput?.id})`
      };
      const userToken = await getAuthToken();
      const res = await fetch(`/.netlify/functions/writeAdminNotification`, {
        method: `POST`,
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${userToken}`
        },
        body: JSON.stringify({ variables })
      });
      if (res) {
        log && console.log(res);
      } else {
        log && console.error("Failed to create notification.");
      }
    } catch (err) {
      console.error(err);
    }
  };
  const canAutoCancel = React.useMemo(() => {
    const result = canAutoCancelMove(moveInput);
    log && console.log(`[MoveCancelModal] Auto-cancel check for Move #${moveInput?.id}:`, result);
    return result;
  }, [moveInput]);
  const moveIds = resolveLegsToCancel(moveInput);
  const isPair = moveIds.length > 1;
  const reasonFor = (moveId) => useSharedReason ? cancelReason : reasonByMoveId[moveId] ?? "";
  const isCancelReasonValid = useSharedReason ? cancelReason.trim().length > 0 : moveIds.every((moveId) => reasonFor(moveId).trim().length > 0);
  const handleClose = () => {
    setCancelReason("");
    setShowError(false);
    if (onClose) onClose();
  };
  const handleSubmit = async () => {
    if (!isCancelReasonValid) {
      setShowError(true);
      toast.error("Please select a cancel reason");
      return;
    }
    try {
      const cancelStatus = canAutoCancel ? "canceled" : "pending";
      if (!canAutoCancel) {
        await createNotification();
      }
      const results = await Promise.all(
        moveIds.map(
          (id) => requestMoveCancelMutation({
            variables: {
              id,
              cancel_status: cancelStatus,
              cancel_reason: reasonFor(id)
            }
          })
        )
      );
      if (results.every((res) => res?.data?.update_moves)) {
        const label = isPair ? `${moveIds.length} moves` : `Move #${moveInput?.id}`;
        log && console.log(`>> UPDATED ${label} with a cancel_status of '${cancelStatus}'.`);
        toast.success(`Cancel request successful for ${label}.`, { toastId: `request-move-cancel` });
        handleClose();
      }
    } catch (err) {
      onError?.(err);
      console.error(`Error updating move:`, err);
      toast.error(`Failed to request move cancelation`);
    }
  };
  React.useEffect(() => {
    if (open) {
      setCancelReason("");
      setShowError(false);
      setUseSharedReason(true);
      setReasonByMoveId({});
    }
  }, [open]);
  const subtitle = isPair ? canAutoCancel ? `Are you sure you want to cancel these moves? ${moveIds.length} moves will be canceled immediately without dispatcher review.` : `Are you sure you want to cancel these moves? Your cancelation will be pending until reviewed by a HopDrive dispatcher.` : canAutoCancel ? `Are you sure you want to cancel this move? This move will be canceled immediately without dispatcher review.` : `Are you sure you want to cancel this move? Your cancelation will be pending until reviewed by a HopDrive dispatcher.`;
  return /* @__PURE__ */ jsx6(Fragment2, { children: /* @__PURE__ */ jsxs3(Modal_default, { open, children: [
    /* @__PURE__ */ jsx6(ModalHeader_default, { handleClose, children: isPair ? `Cancelation Request for ${moveIds.length} Moves` : `Cancelation Request for Move #${moveInput?.id ?? ""}` }),
    /* @__PURE__ */ jsxs3(ModalContent_default, { subtitle, children: [
      isPair ? /* @__PURE__ */ jsx6(
        FormControlLabel,
        {
          control: /* @__PURE__ */ jsx6(
            Checkbox,
            {
              checked: useSharedReason,
              onChange: (e) => {
                setUseSharedReason(e.target.checked);
                setShowError(false);
              }
            }
          ),
          label: "Both moves share the same cancel reason",
          sx: { mb: 1 }
        }
      ) : null,
      (useSharedReason ? [null] : moveIds).map((moveId, i) => {
        const value = moveId === null ? cancelReason : reasonByMoveId[moveId] ?? "";
        const setValue = (next) => moveId === null ? setCancelReason(next) : setReasonByMoveId((prev) => ({ ...prev, [moveId]: next }));
        const isEmpty = value.trim().length === 0;
        return /* @__PURE__ */ jsx6(
          TextField,
          {
            select: true,
            fullWidth: true,
            required: true,
            label: moveId === null ? "Cancel Reason" : `Cancel Reason \u2014 Move #${moveId}`,
            value,
            onChange: (e) => {
              setValue(e?.target?.value || ``);
              setShowError(false);
            },
            error: showError && isEmpty,
            helperText: showError && isEmpty ? "Please select a cancel reason" : "",
            sx: i > 0 ? { mt: 2 } : void 0,
            slotProps: {
              input: {
                startAdornment: /* @__PURE__ */ jsx6(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx6(BiMessageAltDetail, { size: 20 }) })
              }
            },
            children: cancelReasons.map((reason, index) => /* @__PURE__ */ jsx6(MenuItem, { value: reason.value, children: reason.label }, `cancel-reason-${index}`))
          },
          moveId ?? "shared"
        );
      })
    ] }),
    /* @__PURE__ */ jsxs3(ModalFooter_default, { children: [
      /* @__PURE__ */ jsx6(ModalAction_default, { onClick: () => handleSubmit(), disabled: !isCancelReasonValid, children: "Confirm" }),
      /* @__PURE__ */ jsx6(ModalAction_default, { onClick: () => handleClose(), color: "utility", children: "Cancel" })
    ] })
  ] }) });
};
var MoveCancelModal_default = MoveCancelModal;

// src/dialogs/CancelLiteModal.tsx
import React2 from "react";
import { useMutation as useMutation2 } from "@apollo/client";
import { toast as toast2 } from "react-toastify";
import { Checkbox as Checkbox2, FormControlLabel as FormControlLabel2, InputAdornment as InputAdornment2, LinearProgress, MenuItem as MenuItem2, TextField as TextField2 } from "@mui/material";
import { BiMessageAltDetail as BiMessageAltDetail2 } from "react-icons/bi";

// src/dialogs/cancelLiteMove.mutation.generated.ts
import { resolveExecutor as resolveExecutor2 } from "@hopdrive/sdk-core";
var CancelLiteMoveDocument = { "__text": 'mutation cancelLiteMove($moveId: bigint!, $cancelReason: String, $updatedBy: String!) {\n  update_moves_by_pk(\n    pk_columns: {id: $moveId}\n    _set: {cancel_reason: $cancelReason, cancel_requested_at: "now()", cancel_status: "canceled", canceled_at: "now()", updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    id\n    cancel_reason\n    cancel_requested_at\n    cancel_status\n    canceled_at\n    updatedat\n    updatedBy\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "cancelLiteMove" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "cancelReason" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves_by_pk" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "pk_columns" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_reason" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "cancelReason" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_requested_at" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "cancel_status" }, "value": { "kind": "StringValue", "value": "canceled", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "canceled_at" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_reason" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_requested_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "cancel_status" } }, { "kind": "Field", "name": { "kind": "Name", "value": "canceled_at" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedat" } }, { "kind": "Field", "name": { "kind": "Name", "value": "updatedBy" } }] } }] } }] };

// src/dialogs/cancelLiteDecisions.ts
var liteCancelReasons = [
  { label: "Address out of network", value: "Address out of network" },
  { label: "Contact not reachable", value: "Contact not reachable" },
  { label: "Customer canceled previously", value: "Customer canceled previously" },
  { label: "Customer changed address", value: "Customer changed address" },
  { label: "Customer needed to reschedule", value: "Customer needed to reschedule" },
  { label: "Customer not present", value: "Customer not present" },
  { label: "Duplicate move request", value: "Duplicate move request" },
  { label: "Incorrect address", value: "Incorrect address" },
  { label: "Training move", value: "Training move" },
  { label: "Vehicle mechanical failure", value: "Vehicle mechanical failure" },
  { label: "Vehicle moved previously", value: "Vehicle moved previously" },
  { label: "Vehicle not ready", value: "Vehicle not ready" },
  { label: "Vehicle not roadworthy", value: "Vehicle not roadworthy" }
];
var formatLiteMoveLabel = (moveId, isLite) => {
  if (!moveId) return `-`;
  return `${isLite ? `L-` : `#`}${moveId}`;
};
var resolveDuplicatePlannerState = (move) => {
  const parentDrive = move?.parentMove;
  const childDrive = move?.childMoves?.find((cm) => cm?.move_type === `drive`);
  const moveId1 = parentDrive?.id || move?.id;
  const moveId2 = childDrive?.id || move?.id;
  const state = { moveId1: moveId1 ?? void 0, inverse: false };
  if (moveId2 && moveId2 !== moveId1) state.moveId2 = moveId2;
  return state;
};

// src/dialogs/CancelLiteModal.tsx
import { Fragment as Fragment3, jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var log2 = false;
var CancelLiteModalContent = (props) => {
  const { onClose, move, actor, onCreateDuplicate, onError } = props;
  const [isSaving, setIsSaving] = React2.useState(false);
  const [cancelReason, setCancelReason] = React2.useState(``);
  const [useSharedReason, setUseSharedReason] = React2.useState(true);
  const [reasonByMoveId, setReasonByMoveId] = React2.useState({});
  const [cancelLiteMoveMutation] = useMutation2(CancelLiteMoveDocument);
  const handleCreateDuplicate = () => {
    onCreateDuplicate(resolveDuplicatePlannerState(move));
  };
  const moveIds = resolveLegsToCancel(move);
  const isPair = moveIds.length > 1;
  const reasonFor = (moveId) => useSharedReason ? cancelReason : reasonByMoveId[moveId] ?? ``;
  const handleSubmit = async (duplicate = false) => {
    setIsSaving(true);
    const label = isPair ? `${moveIds.length} moves` : `Move #${move?.id}`;
    try {
      const results = await Promise.all(
        moveIds.map(
          (moveId) => cancelLiteMoveMutation({
            variables: {
              moveId,
              cancelReason: reasonFor(moveId),
              updatedBy: actor || `system`
            }
          })
        )
      );
      if (results.every((res) => res?.data?.update_moves_by_pk?.id)) {
        log2 && console.log(`Successfully canceled ${label}.`);
        toast2.success(`Successfully canceled ${label}.`, {
          toastId: `cancel-lite-move-success`
        });
        handleClose({ refresh: true });
      }
    } catch (err) {
      onError?.(err);
      console.log(`Failed to cancel ${label}:`, err);
      toast2.error(`Failed to cancel ${label}.`, { toastId: `cancel-lite-move-error` });
    }
    if (duplicate) handleCreateDuplicate();
    setIsSaving(false);
  };
  const handleClose = (output) => {
    if (onClose) onClose(output);
  };
  return /* @__PURE__ */ jsxs4(Fragment3, { children: [
    /* @__PURE__ */ jsx7(ModalHeader_default, { handleClose, children: isPair ? `Cancel ${moveIds.length} Moves` : `Cancel Move ${formatLiteMoveLabel(move?.id, move?.lite)}` }),
    /* @__PURE__ */ jsxs4(
      ModalContent_default,
      {
        subtitle: isPair ? `Canceling will remove ${moveIds.length} moves from the driver's app. Optionally select a reason for them being canceled. If you would like to create duplicates to be completed later, please select the "Submit & Reschedule" option.` : `Canceling this move will remove it from the driver's app. Optionally select a reason for this move being canceled. If you would like to create a duplicate of this move to be completed later, please select the "Submit & Reschedule" option.`,
        children: [
          isPair ? /* @__PURE__ */ jsx7(
            FormControlLabel2,
            {
              control: /* @__PURE__ */ jsx7(Checkbox2, { checked: useSharedReason, onChange: (e) => setUseSharedReason(e.target.checked) }),
              label: "Both moves share the same cancel reason",
              sx: { mb: 1 }
            }
          ) : null,
          (useSharedReason ? [null] : moveIds).map((moveId, i) => {
            const value = moveId === null ? cancelReason : reasonByMoveId[moveId] ?? ``;
            const setValue = (next) => moveId === null ? setCancelReason(next) : setReasonByMoveId((prev) => ({ ...prev, [moveId]: next }));
            return /* @__PURE__ */ jsxs4(
              TextField2,
              {
                select: true,
                fullWidth: true,
                label: moveId === null ? `Cancel Reason` : `Cancel Reason \u2014 Move #${moveId}`,
                value,
                onChange: (e) => setValue(e?.target?.value || ``),
                sx: i > 0 ? { mt: 2 } : void 0,
                slotProps: {
                  input: {
                    startAdornment: /* @__PURE__ */ jsx7(InputAdornment2, { position: "start", children: /* @__PURE__ */ jsx7(BiMessageAltDetail2, { size: 20 }) })
                  }
                },
                children: [
                  /* @__PURE__ */ jsx7(MenuItem2, { value: "", sx: { color: "text.secondary" }, children: /* @__PURE__ */ jsx7("em", { children: "None" }) }),
                  liteCancelReasons.map((reason, index) => /* @__PURE__ */ jsx7(MenuItem2, { value: reason.value, children: reason.label }, `cancel-reason-${index}`))
                ]
              },
              moveId ?? `shared`
            );
          })
        ]
      }
    ),
    isSaving ? /* @__PURE__ */ jsx7(LinearProgress, {}) : null,
    /* @__PURE__ */ jsxs4(ModalFooter_default, { children: [
      /* @__PURE__ */ jsx7(ModalAction_default, { disabled: isSaving, variant: "contained", color: "error", onClick: () => handleSubmit(), children: "Submit" }),
      /* @__PURE__ */ jsx7(ModalAction_default, { disabled: isSaving, variant: "outlined", color: "error", onClick: () => handleSubmit(true), children: "Submit & Reschedule" }),
      /* @__PURE__ */ jsx7(ModalAction_default, { color: "utility", onClick: () => handleClose(), children: "Cancel" })
    ] })
  ] });
};
var CancelLiteModal = ({ open, moveInput, ...contentProps }) => {
  return /* @__PURE__ */ jsx7(Modal_default, { open, children: open && moveInput ? /* @__PURE__ */ jsx7(CancelLiteModalContent, { ...contentProps, move: moveInput }) : null });
};
var CancelLiteModal_default = CancelLiteModal;

// src/dialogs/MoveTimeModal.tsx
import React3 from "react";
import { useMutation as useMutation3 } from "@apollo/client";
import { toast as toast3 } from "react-toastify";
import dayjs2 from "dayjs";
import utc2 from "dayjs/plugin/utc";
import { css } from "@emotion/css";
import { useTheme as useTheme5, TextField as TextField3, Typography as Typography2 } from "@mui/material";
import { BiError, BiSolidCalendarExclamation } from "react-icons/bi";

// src/dialogs/requestAppointmentTimeChange.mutation.generated.ts
import { resolveExecutor as resolveExecutor3 } from "@hopdrive/sdk-core";
var RequestAppointmentTimeChangeDocument = { "__text": 'mutation requestAppointmentTimeChange($moveId: bigint!, $readyByTime: timestamptz!, $pickupTime: timestamptz!, $deliveryTime: timestamptz!, $targetPickupTime: timestamptz!, $updatedBy: String) {\n  update_moves(\n    where: {id: {_eq: $moveId}}\n    _set: {ready_by: $readyByTime, pickup_time: $pickupTime, delivery_time: $deliveryTime, target_pickup_time: $targetPickupTime, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n      target_pickup_time\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestAppointmentTimeChange" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "targetPickupTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "target_pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "targetPickupTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "target_pickup_time" } }] } }] } }] } }] };

// src/dialogs/requestLinkedPairTimeChange.mutation.generated.ts
import { resolveExecutor as resolveExecutor4 } from "@hopdrive/sdk-core";
var RequestLinkedPairTimeChangeDocument = { "__text": 'mutation requestLinkedPairTimeChange($moveId1: bigint!, $readyByTime1: timestamptz!, $pickupTime1: timestamptz!, $deliveryTime1: timestamptz!, $moveId2: bigint!, $readyByTime2: timestamptz!, $pickupTime2: timestamptz!, $deliveryTime2: timestamptz!, $updatedBy: String) {\n  leg1: update_moves(\n    where: {id: {_eq: $moveId1}}\n    _set: {ready_by: $readyByTime1, pickup_time: $pickupTime1, delivery_time: $deliveryTime1, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n    }\n  }\n  leg2: update_moves(\n    where: {id: {_eq: $moveId2}}\n    _set: {ready_by: $readyByTime2, pickup_time: $pickupTime2, delivery_time: $deliveryTime2, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestLinkedPairTimeChange" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "leg1" }, "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId1" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "leg2" }, "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId2" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }] } }] } }] } }] };

// src/dialogs/requestMoveTimeChange.mutation.generated.ts
import { resolveExecutor as resolveExecutor5 } from "@hopdrive/sdk-core";
var RequestMoveTimeChangeDocument = { "__text": 'mutation requestMoveTimeChange($moveId: bigint!, $readyByTime: timestamptz!, $pickupTime: timestamptz!, $deliveryTime: timestamptz!, $updatedBy: String) {\n  update_moves(\n    where: {id: {_eq: $moveId}}\n    _set: {ready_by: $readyByTime, pickup_time: $pickupTime, delivery_time: $deliveryTime, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestMoveTimeChange" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }] } }] } }] } }] };

// src/dialogs/requestPairTimeChange.mutation.generated.ts
import { resolveExecutor as resolveExecutor6 } from "@hopdrive/sdk-core";
var RequestPairTimeChangeDocument = { "__text": 'mutation requestPairTimeChange($moveId1: bigint!, $readyByTime1: timestamptz!, $pickupTime1: timestamptz!, $deliveryTime1: timestamptz!, $moveId2: bigint!, $readyByTime2: timestamptz!, $pickupTime2: timestamptz!, $deliveryTime2: timestamptz!, $targetPickupTime: timestamptz!, $updatedBy: String) {\n  leg1: update_moves(\n    where: {id: {_eq: $moveId1}}\n    _set: {ready_by: $readyByTime1, pickup_time: $pickupTime1, delivery_time: $deliveryTime1, target_pickup_time: $targetPickupTime, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n      target_pickup_time\n    }\n  }\n  leg2: update_moves(\n    where: {id: {_eq: $moveId2}}\n    _set: {ready_by: $readyByTime2, pickup_time: $pickupTime2, delivery_time: $deliveryTime2, target_pickup_time: $targetPickupTime, updatedat: "now()", updatedBy: $updatedBy}\n  ) {\n    affected_rows\n    returning {\n      id\n      ready_by\n      pickup_time\n      delivery_time\n      target_pickup_time\n    }\n  }\n}', "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "mutation", "name": { "kind": "Name", "value": "requestPairTimeChange" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime1" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "bigint" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime2" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "targetPickupTime" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "timestamptz" } } } }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } }, "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "String" } } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": { "kind": "Name", "value": "leg1" }, "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId1" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime1" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "target_pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "targetPickupTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "target_pickup_time" } }] } }] } }, { "kind": "Field", "alias": { "kind": "Name", "value": "leg2" }, "name": { "kind": "Name", "value": "update_moves" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "where" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "id" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "_eq" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "moveId2" } } }] } }] } }, { "kind": "Argument", "name": { "kind": "Name", "value": "_set" }, "value": { "kind": "ObjectValue", "fields": [{ "kind": "ObjectField", "name": { "kind": "Name", "value": "ready_by" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "readyByTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "pickupTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "delivery_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "deliveryTime2" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "target_pickup_time" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "targetPickupTime" } } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedat" }, "value": { "kind": "StringValue", "value": "now()", "block": false } }, { "kind": "ObjectField", "name": { "kind": "Name", "value": "updatedBy" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "updatedBy" } } }] } }], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "affected_rows" } }, { "kind": "Field", "name": { "kind": "Name", "value": "returning" }, "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "name": { "kind": "Name", "value": "id" } }, { "kind": "Field", "name": { "kind": "Name", "value": "ready_by" } }, { "kind": "Field", "name": { "kind": "Name", "value": "pickup_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "delivery_time" } }, { "kind": "Field", "name": { "kind": "Name", "value": "target_pickup_time" } }] } }] } }] } }] };

// src/dialogs/moveTimeDecisions.ts
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
var resolvePairedLeg = (move) => {
  if (!move) return null;
  if (isLiveDriveLeg(move.parentMove)) return move.parentMove;
  const childDrive = move.childMoves?.find(isLiveDriveLeg);
  return childDrive || null;
};
var orderPairLegs = (move, pairedLeg) => {
  const own = move.pickup_time ? new Date(move.pickup_time).getTime() : NaN;
  const sibling = pairedLeg.pickup_time ? new Date(pairedLeg.pickup_time).getTime() : NaN;
  const moveIsFirst = Number.isNaN(own) || Number.isNaN(sibling) || own === sibling ? (move.id || 0) < (pairedLeg.id || 0) : own < sibling;
  return moveIsFirst ? [move, pairedLeg] : [pairedLeg, move];
};
var isAppointmentStyleMove = (move) => {
  if (!move) return false;
  if (move.target_pickup_time) return true;
  const pairedLeg = resolvePairedLeg(move);
  return !!pairedLeg?.target_pickup_time;
};
var resolveMoveTimeShape = (move) => {
  const isAppointmentStyle = isAppointmentStyleMove(move);
  const pairedLeg = resolvePairedLeg(move);
  const [firstLeg, secondLeg] = pairedLeg && move ? orderPairLegs(move, pairedLeg) : [move ?? null, null];
  return {
    isAppointmentStyle,
    pairedLeg,
    isAppointmentPair: isAppointmentStyle && !!pairedLeg,
    isLinkedPair: !isAppointmentStyle && !!pairedLeg,
    firstLeg,
    secondLeg
  };
};
var resolveTimeFloorDecision = ({
  selectedTime,
  now
}) => {
  const selected = selectedTime ? dayjs(selectedTime) : null;
  if (!selected || !selected.isValid()) return { action: `accept` };
  const selectedMinute = selected.startOf(`minute`);
  const base = now ? dayjs(now) : dayjs();
  const floorMinute = base.add(90, `minute`).startOf(`minute`);
  if (selectedMinute.isSame(floorMinute) || selectedMinute.isAfter(floorMinute)) return { action: `accept` };
  return { action: `adjust`, adjustedTime: base.add(91, `minute`).startOf(`minute`).format() };
};
var buildTimeChangePayload = ({
  newTime,
  laneDurationSec,
  storedPickupTime,
  storedDeliveryTime,
  isAppointmentStyle
}) => {
  const base = newTime ? dayjs(newTime) : null;
  if (!base || !base.isValid()) return null;
  let windowSec = laneDurationSec && laneDurationSec > 0 ? laneDurationSec : 0;
  if (!windowSec && storedPickupTime && storedDeliveryTime) {
    const storedPickup = dayjs(storedPickupTime);
    const storedDelivery = dayjs(storedDeliveryTime);
    if (storedPickup.isValid() && storedDelivery.isValid()) {
      windowSec = Math.max(storedDelivery.diff(storedPickup, `second`), 0);
    }
  }
  const time = base.utc().format();
  const payload = {
    readyByTime: time,
    pickupTime: time,
    deliveryTime: base.add(windowSec, `second`).utc().format()
  };
  if (isAppointmentStyle) payload.targetPickupTime = time;
  return payload;
};
var toPairLegInput = (leg) => ({
  id: leg?.id,
  storedPickupTime: leg?.pickup_time,
  storedDeliveryTime: leg?.delivery_time,
  storedTargetPickupTime: leg?.target_pickup_time,
  laneDurationSec: leg?.lane?.duration_sec
});
var resolveLegWindowSec = (leg) => {
  if (leg.laneDurationSec && leg.laneDurationSec > 0) return leg.laneDurationSec;
  if (leg.storedPickupTime && leg.storedDeliveryTime) {
    const pickup = dayjs(leg.storedPickupTime);
    const delivery = dayjs(leg.storedDeliveryTime);
    if (pickup.isValid() && delivery.isValid()) return Math.max(delivery.diff(pickup, `second`), 0);
  }
  return 0;
};
var resolveLinkedPairOffsetSec = (firstLeg, secondLeg) => {
  if (firstLeg?.laneDurationSec && firstLeg.laneDurationSec > 0) return firstLeg.laneDurationSec;
  const first = firstLeg?.storedPickupTime ? dayjs(firstLeg.storedPickupTime) : null;
  const second = secondLeg?.storedPickupTime ? dayjs(secondLeg.storedPickupTime) : null;
  if (first && second && first.isValid() && second.isValid()) {
    return Math.max(second.diff(first, `second`), 0);
  }
  return 0;
};
var buildLinkedPairTimeChangePayload = ({
  firstTime,
  secondTime,
  firstLeg,
  secondLeg
}) => {
  const first = firstTime ? dayjs(firstTime) : null;
  const second = secondTime ? dayjs(secondTime) : null;
  if (!first || !second || !first.isValid() || !second.isValid()) return null;
  if (!firstLeg?.id || !secondLeg?.id) return null;
  const buildLinkedLeg = (leg, start) => ({
    moveId: leg.id,
    readyByTime: start.utc().format(),
    pickupTime: start.utc().format(),
    deliveryTime: start.add(resolveLegWindowSec(leg), `second`).utc().format()
  });
  return { legs: [buildLinkedLeg(firstLeg, first), buildLinkedLeg(secondLeg, second)] };
};
var buildPairTimeChangePayload = ({
  appointmentTime,
  legs
}) => {
  const appointment = appointmentTime ? dayjs(appointmentTime) : null;
  if (!appointment || !appointment.isValid()) return null;
  const [legA, legB] = legs || [];
  if (!legA?.id || !legB?.id) return null;
  const storedAppointmentRaw = [legA, legB].map((leg) => leg.storedTargetPickupTime).find(Boolean);
  const storedAppointment = storedAppointmentRaw ? dayjs(storedAppointmentRaw) : null;
  if (!storedAppointment || !storedAppointment.isValid()) return null;
  const deltaSec = appointment.diff(storedAppointment, `second`);
  const buildLeg = (leg) => {
    const storedPickup = leg.storedPickupTime ? dayjs(leg.storedPickupTime) : null;
    const basePickup = storedPickup && storedPickup.isValid() ? storedPickup : storedAppointment;
    const newPickup = basePickup.add(deltaSec, `second`);
    return {
      moveId: leg.id,
      readyByTime: newPickup.utc().format(),
      pickupTime: newPickup.utc().format(),
      deliveryTime: newPickup.add(resolveLegWindowSec(leg), `second`).utc().format(),
      targetPickupTime: appointment.utc().format()
    };
  };
  const built = [buildLeg(legA), buildLeg(legB)];
  const firstLegPickupTime = built.map((leg) => leg.pickupTime).sort()[0];
  return { legs: built, firstLegPickupTime };
};
var resolveSeedTimes = ({
  move,
  shape,
  linkedOffsetSec = 0
}) => {
  const seedTime = shape.isAppointmentPair ? move?.target_pickup_time || shape.pairedLeg?.target_pickup_time : shape.isLinkedPair ? shape.firstLeg?.ready_by : move?.ready_by;
  const seedTime2 = shape.isLinkedPair ? shape.secondLeg?.ready_by : null;
  const first = dayjs(seedTime);
  const firstDate = first.format(`YYYY-MM-DD`) || ``;
  const firstTime = first.format(`HH:mm`) || ``;
  if (!shape.isLinkedPair) return { firstDate, firstTime, secondDate: ``, secondTime: `` };
  const second = seedTime2 && dayjs(seedTime2).isValid() ? dayjs(seedTime2) : seedTime && dayjs(seedTime).isValid() ? dayjs(seedTime).add(linkedOffsetSec, `second`) : null;
  return {
    firstDate,
    firstTime,
    secondDate: second ? second.format(`YYYY-MM-DD`) : ``,
    secondTime: second ? second.format(`HH:mm`) : ``
  };
};

// src/dialogs/MoveTimeModal.tsx
import { Fragment as Fragment4, jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
dayjs2.extend(utc2);
var MoveTimeModal = ({ open, onClose, moveInput, actor }) => {
  const theme = useTheme5();
  const cls = useStyles(theme);
  const [requestMoveTimeChangeMutation] = useMutation3(RequestMoveTimeChangeDocument);
  const [requestAppointmentTimeChangeMutation] = useMutation3(RequestAppointmentTimeChangeDocument);
  const [requestPairTimeChangeMutation] = useMutation3(RequestPairTimeChangeDocument);
  const [requestLinkedPairTimeChangeMutation] = useMutation3(RequestLinkedPairTimeChangeDocument);
  const shape = resolveMoveTimeShape(moveInput);
  const { isAppointmentStyle, pairedLeg, isAppointmentPair, isLinkedPair, firstLeg, secondLeg } = shape;
  const [myDate, setMyDate] = React3.useState(``);
  const [myTime, setMyTime] = React3.useState(``);
  const [time, setTime] = React3.useState(``);
  const [myDate2, setMyDate2] = React3.useState(``);
  const [myTime2, setMyTime2] = React3.useState(``);
  const time2 = myDate2 && myTime2 ? dayjs2(`${myDate2}T${myTime2}`).utc().format() : ``;
  const pairPreview = isAppointmentPair ? buildPairTimeChangePayload({
    appointmentTime: time,
    legs: [toPairLegInput(moveInput), toPairLegInput(pairedLeg)]
  }) : null;
  const linkedOffsetSec = isLinkedPair ? resolveLinkedPairOffsetSec(toPairLegInput(firstLeg), toPairLegInput(secondLeg)) : 0;
  const applySeeds = () => {
    const seeds = resolveSeedTimes({ move: moveInput, shape, linkedOffsetSec });
    setMyDate(seeds.firstDate);
    setMyTime(seeds.firstTime);
    setMyDate2(seeds.secondDate);
    setMyTime2(seeds.secondTime);
  };
  React3.useEffect(() => {
    if (open && moveInput) applySeeds();
  }, [open]);
  React3.useEffect(() => {
    if (open && myDate && myTime) {
      const decision = resolveTimeFloorDecision({ selectedTime: `${myDate}T${myTime}` });
      if (decision.action === `adjust`) {
        toast3.warning(`Time was adjusted to be at least 90 minutes from now.`, { toastId: `move-details-time-change` });
        const adjusted = dayjs2(decision.adjustedTime);
        setMyDate(adjusted.format(`YYYY-MM-DD`));
        setMyTime(adjusted.format(`HH:mm`));
        setTime(adjusted.utc().format());
        if (isLinkedPair) {
          const derived = adjusted.add(linkedOffsetSec, `second`);
          setMyDate2(derived.format(`YYYY-MM-DD`));
          setMyTime2(derived.format(`HH:mm`));
        }
        return;
      }
      setTime(dayjs2(`${myDate}T${myTime}`).utc().format());
    } else {
      setTime(``);
    }
  }, [open, myDate, myTime]);
  const handleRowChange = (row, nextDate, nextTime) => {
    if (row === `first`) {
      setMyDate(nextDate);
      setMyTime(nextTime);
    } else {
      setMyDate2(nextDate);
      setMyTime2(nextTime);
    }
    if (!isLinkedPair || !nextDate || !nextTime) return;
    const selected = dayjs2(`${nextDate}T${nextTime}`);
    if (!selected.isValid()) return;
    const derived = row === `first` ? selected.add(linkedOffsetSec, `second`) : selected.subtract(linkedOffsetSec, `second`);
    if (row === `first`) {
      setMyDate2(derived.format(`YYYY-MM-DD`));
      setMyTime2(derived.format(`HH:mm`));
    } else {
      setMyDate(derived.format(`YYYY-MM-DD`));
      setMyTime(derived.format(`HH:mm`));
    }
  };
  const handleSubmit = async () => {
    try {
      if (!moveInput?.id) return;
      if (isLinkedPair) {
        const linkedPayload = buildLinkedPairTimeChangePayload({
          firstTime: time,
          secondTime: time2,
          firstLeg: toPairLegInput(firstLeg),
          secondLeg: toPairLegInput(secondLeg)
        });
        if (!linkedPayload) return;
        const [legA, legB] = linkedPayload.legs;
        const res2 = await requestLinkedPairTimeChangeMutation({
          variables: {
            moveId1: legA.moveId,
            readyByTime1: legA.readyByTime,
            pickupTime1: legA.pickupTime,
            deliveryTime1: legA.deliveryTime,
            moveId2: legB.moveId,
            readyByTime2: legB.readyByTime,
            pickupTime2: legB.pickupTime,
            deliveryTime2: legB.deliveryTime,
            updatedBy: actor
          }
        });
        if (res2?.data?.leg1?.affected_rows && res2?.data?.leg2?.affected_rows) {
          toast3.success(`Successfully updated move times!`);
          handleClose();
        }
        return;
      }
      if (isAppointmentPair) {
        const pairPayload = buildPairTimeChangePayload({
          appointmentTime: time,
          legs: [toPairLegInput(moveInput), toPairLegInput(pairedLeg)]
        });
        if (!pairPayload) return;
        const [legA, legB] = pairPayload.legs;
        const res2 = await requestPairTimeChangeMutation({
          variables: {
            moveId1: legA.moveId,
            readyByTime1: legA.readyByTime,
            pickupTime1: legA.pickupTime,
            deliveryTime1: legA.deliveryTime,
            moveId2: legB.moveId,
            readyByTime2: legB.readyByTime,
            pickupTime2: legB.pickupTime,
            deliveryTime2: legB.deliveryTime,
            targetPickupTime: legA.targetPickupTime,
            updatedBy: actor
          }
        });
        if (res2?.data?.leg1?.affected_rows && res2?.data?.leg2?.affected_rows) {
          toast3.success(`Successfully updated appointment time!`);
          handleClose();
        }
        return;
      }
      const payload = buildTimeChangePayload({
        newTime: time,
        laneDurationSec: moveInput?.lane?.duration_sec,
        storedPickupTime: moveInput?.pickup_time,
        storedDeliveryTime: moveInput?.delivery_time,
        isAppointmentStyle
      });
      if (!payload) return;
      const variables = { moveId: moveInput.id, updatedBy: actor, ...payload };
      const res = isAppointmentStyle ? await requestAppointmentTimeChangeMutation({
        variables: { ...variables, targetPickupTime: payload.targetPickupTime || payload.pickupTime }
      }) : await requestMoveTimeChangeMutation({ variables });
      if (res?.data?.update_moves?.affected_rows) {
        toast3.success(`Successfully updated ready time!`);
        handleClose();
      }
    } catch (err) {
      console.error(`Failed to update ready time:`, err);
      toast3.error(`Failed to update ready time!`);
    }
  };
  const handleClose = () => {
    applySeeds();
    if (onClose) onClose();
  };
  return /* @__PURE__ */ jsx8(Fragment4, { children: /* @__PURE__ */ jsxs5(Modal_default, { open, children: [
    /* @__PURE__ */ jsx8(ModalHeader_default, { handleClose, children: "Change Start Time" }),
    /* @__PURE__ */ jsx8(ModalContent_default, { children: /* @__PURE__ */ jsxs5("div", { className: cls.time, children: [
      /* @__PURE__ */ jsxs5("div", { className: cls.title, children: [
        /* @__PURE__ */ jsx8(BiSolidCalendarExclamation, { className: cls.titleIcon }),
        /* @__PURE__ */ jsx8(Typography2, { variant: "body2", sx: { color: theme?.palette?.text?.secondary }, children: isAppointmentStyle ? `Select the date & time of the appointment with your customer. Timezone is local to your machine. Must be at least 90 minutes in the future.` : `Select the date & time your vehicle(s) will be ready for transport. Timezone is local to your machine. Must be at least 90 minutes in the future. NOTE: This is not an appointment time, but an estimate so we can determine when to dispatch a driver to complete the move. The pickup time may vary based on volume and driver availability.` })
      ] }),
      isAppointmentPair ? /* @__PURE__ */ jsxs5("div", { className: cls.pairWarning, children: [
        /* @__PURE__ */ jsx8(BiError, { className: cls.pairWarningIcon }),
        /* @__PURE__ */ jsxs5(Typography2, { variant: "body2", sx: { color: theme?.palette?.text?.primary }, children: [
          `This appointment includes a paired move \u2014 both will be rescheduled together.`,
          pairPreview ? ` The first move will start at ${dayjs2(pairPreview.firstLegPickupTime).local().format(`MM/DD/YYYY h:mm A`)}.` : ``
        ] })
      ] }) : null,
      isLinkedPair ? /* @__PURE__ */ jsxs5("div", { className: cls.pairWarning, children: [
        /* @__PURE__ */ jsx8(BiError, { className: cls.pairWarningIcon }),
        /* @__PURE__ */ jsx8(Typography2, { variant: "body2", sx: { color: theme?.palette?.text?.primary }, children: `These moves are linked \u2014 editing one automatically adjusts the other to keep them in sync.` })
      ] }) : null,
      isLinkedPair ? /* @__PURE__ */ jsx8(
        Typography2,
        {
          sx: { marginTop: `16px`, marginBottom: `8px`, fontSize: `16px`, fontWeight: `700` },
          children: `First Move #${firstLeg?.id || ``}`
        }
      ) : null,
      /* @__PURE__ */ jsxs5("div", { className: cls.flex, children: [
        /* @__PURE__ */ jsxs5("div", { className: cls.flexItem, children: [
          /* @__PURE__ */ jsxs5("label", { className: cls.textFieldLabel, htmlFor: "date-select", children: [
            isAppointmentStyle ? `Appointment Date` : `Ready By Date`,
            /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
          ] }),
          /* @__PURE__ */ jsx8(
            TextField3,
            {
              fullWidth: true,
              required: true,
              name: "date-select",
              type: "date",
              placeholder: "Select a date...",
              value: myDate || ``,
              onChange: (e) => handleRowChange(`first`, e?.target?.value, myTime),
              slotProps: {
                htmlInput: {
                  min: dayjs2().format(`YYYY-MM-DD`)
                }
              }
            }
          )
        ] }),
        /* @__PURE__ */ jsxs5("div", { className: cls.flexItem, children: [
          /* @__PURE__ */ jsxs5("label", { className: cls.textFieldLabel, htmlFor: "time-select", children: [
            isAppointmentStyle ? `Appointment Time` : `Ready By Time`,
            /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
          ] }),
          /* @__PURE__ */ jsx8(
            TextField3,
            {
              fullWidth: true,
              required: true,
              name: "time-select",
              type: "time",
              placeholder: "Select a time...",
              value: myTime || ``,
              onChange: (e) => handleRowChange(`first`, myDate, e?.target?.value),
              slotProps: {
                htmlInput: {
                  min: myDate <= dayjs2().add(90, `minute`).format(`YYYY-MM-DD`) ? dayjs2().add(90, `minute`).format(`HH:mm`) : `00:00`,
                  step: 300
                  // 5 minutes
                }
              }
            }
          )
        ] })
      ] }),
      isLinkedPair ? /* @__PURE__ */ jsxs5(Fragment4, { children: [
        /* @__PURE__ */ jsx8(
          Typography2,
          {
            sx: { marginTop: `16px`, marginBottom: `8px`, fontSize: `16px`, fontWeight: `700` },
            children: `Second Move #${secondLeg?.id || ``}`
          }
        ),
        /* @__PURE__ */ jsxs5("div", { className: cls.flex, children: [
          /* @__PURE__ */ jsxs5("div", { className: cls.flexItem, children: [
            /* @__PURE__ */ jsxs5("label", { className: cls.textFieldLabel, htmlFor: "date-select-2", children: [
              `Ready By Date`,
              /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
            ] }),
            /* @__PURE__ */ jsx8(
              TextField3,
              {
                fullWidth: true,
                required: true,
                name: "date-select-2",
                type: "date",
                placeholder: "Select a date...",
                value: myDate2 || ``,
                onChange: (e) => handleRowChange(`second`, e?.target?.value, myTime2),
                slotProps: {
                  htmlInput: {
                    min: dayjs2().format(`YYYY-MM-DD`)
                  }
                }
              }
            )
          ] }),
          /* @__PURE__ */ jsxs5("div", { className: cls.flexItem, children: [
            /* @__PURE__ */ jsxs5("label", { className: cls.textFieldLabel, htmlFor: "time-select-2", children: [
              `Ready By Time`,
              /* @__PURE__ */ jsx8("span", { className: cls.textFieldLabelRequired, children: " *" })
            ] }),
            /* @__PURE__ */ jsx8(
              TextField3,
              {
                fullWidth: true,
                required: true,
                name: "time-select-2",
                type: "time",
                placeholder: "Select a time...",
                value: myTime2 || ``,
                onChange: (e) => handleRowChange(`second`, myDate2, e?.target?.value),
                slotProps: {
                  htmlInput: {
                    step: 300
                    // 5 minutes
                  }
                }
              }
            )
          ] })
        ] })
      ] }) : null
    ] }) }),
    /* @__PURE__ */ jsxs5(ModalFooter_default, { children: [
      /* @__PURE__ */ jsx8(
        ModalAction_default,
        {
          disabled: !time || time === `Invalid Date` || isLinkedPair && (!time2 || time2 === `Invalid Date`),
          onClick: () => handleSubmit(),
          children: "Confirm"
        }
      ),
      /* @__PURE__ */ jsx8(ModalAction_default, { onClick: () => handleClose(), color: "utility", children: "Cancel" })
    ] })
  ] }) });
};
var useStyles = (theme) => ({
  time: css`
    position: relative;
    /* text-align: left; */
  `,
  title: css`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border: 1px solid ${theme?.palette?.divider};
    border-radius: 10px;
    margin-bottom: 12px;
    background-color: ${theme?.palette?.action?.hover};
  `,
  titleIcon: css`
    min-width: 20px;
    min-height: 20px;
    margin-top: -2px;
    font-size: 20px;
    color: ${theme?.palette?.text?.secondary};
  `,
  pairWarning: css`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px;
    border: 1px solid ${theme?.palette?.warning?.main}40;
    border-radius: 10px;
    margin-bottom: 12px;
    background-color: ${theme?.palette?.warning?.main}14;
  `,
  pairWarningIcon: css`
    min-width: 20px;
    min-height: 20px;
    margin-top: -2px;
    font-size: 20px;
    color: ${theme?.palette?.warning?.main};
  `,
  textFieldLabel: css`
    display: block;
    margin-bottom: 2px;
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
  `,
  textFieldLabelInvisible: css`
    display: block;
    margin-bottom: 2px;
    margin-left: 6px;
    font-size: 12px;
    font-weight: 600;
    color: transparent;
    user-select: none;
    ${theme?.breakpoints?.down("md")} {
      display: none;
    }
  `,
  textFieldLabelRequired: css`
    color: ${theme?.palette?.error?.main};
  `,
  flex: css`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
    ${theme?.breakpoints?.down("md")} {
      flex-direction: column;
    }
  `,
  flexItem: css`
    flex: 2;
    width: 100%;
  `,
  flexItemSmall: css`
    flex: 1;
    width: 100%;
  `
});
var MoveTimeModal_default = MoveTimeModal;
export {
  CancelLiteModal_default as CancelLiteModal,
  MoveCancelModal_default as MoveCancelModal,
  MoveTimeModal_default as MoveTimeModal,
  buildLinkedPairTimeChangePayload,
  buildPairTimeChangePayload,
  buildTimeChangePayload,
  canAutoCancelMove,
  cancelReasons,
  formatLiteMoveLabel,
  isAppointmentStyleMove,
  liteCancelReasons,
  orderPairLegs,
  resolveDuplicatePlannerState,
  resolveLegsToCancel,
  resolveLinkedPairOffsetSec,
  resolveMoveTimeShape,
  resolvePairedLeg,
  resolveSeedTimes,
  resolveTimeFloorDecision,
  toPairLegInput
};
//# sourceMappingURL=index.mjs.map